var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('div',{attrs:{"id":"help_menu"}},_vm._l((_vm.menu),function(item,index){return _c('router-link',{key:'help_menu_' + index,attrs:{"to":{ name: item.slug }}},[_c('div',{staticClass:"help_menu_element",class:{
					'active-bg': _vm.$route.name == item.slug ? true : false
				}},[_c('span',[_vm._v(" "+_vm._s(item.label)+" ")])])])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }